document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    if (!form) return;

    var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    var optionSets = Array.from(form.querySelectorAll('[data-option-set]'));
    var presentationSet = optionSets.find(function (set) { return /presentation/i.test(set.dataset.optionName); });
    var frameSet = optionSets.find(function (set) { return /^frame$/i.test(set.dataset.optionName); });
    var preview = root.querySelector('.live-frame');
    var caption = root.querySelector('[data-preview-caption]');
    var summary = root.querySelector('[data-selection-summary]');
    var price = root.querySelector('[data-price]');
    var button = form.querySelector('[type="submit"]');

    function checkedValue(set) {
      var checked = set && set.querySelector('[data-product-option]:checked');
      return checked ? checked.value : '';
    }

    function selectFrame(value) {
      if (!frameSet) return;
      var input = Array.from(frameSet.querySelectorAll('[data-product-option]')).find(function (radio) {
        return radio.value.toLowerCase() === value.toLowerCase();
      });
      if (input) input.checked = true;
    }

    function update() {
      var presentation = checkedValue(presentationSet);
      if (/unframed/i.test(presentation)) {
        selectFrame('None');
        if (frameSet) frameSet.classList.add('is-disabled');
      } else if (/framed/i.test(presentation)) {
        if (frameSet) frameSet.classList.remove('is-disabled');
        if (!checkedValue(frameSet) || /^none$/i.test(checkedValue(frameSet))) selectFrame('Black');
      }

      var selected = optionSets.map(checkedValue);
      var variant = variants.find(function (item) {
        return item.options.every(function (value, index) { return value === selected[index]; });
      });

      var size = selected[0] || '';
      var frame = checkedValue(frameSet);
      var isUnframed = /unframed/i.test(presentation);
      var previewClass = isUnframed ? 'unframed' : frame.toLowerCase().replace(/\s+/g, '-');

      if (preview) preview.className = 'product-art live-frame ' + previewClass;
      if (caption) caption.textContent = isUnframed ? 'Preview · Unframed print' : 'Preview · ' + frame.replace('Wooden Oak', 'Oak') + ' frame';
      if (summary) summary.textContent = isUnframed ? size + ' · Unframed' : size + ' · Framed · ' + frame.replace('Wooden Oak', 'Oak');

      if (!variant) {
        button.disabled = true;
        button.querySelector('span').textContent = 'Selection unavailable';
        return;
      }

      form.querySelector('[data-variant-id]').value = variant.id;
      price.textContent = new Intl.NumberFormat('en-ZA', {
        style: 'currency', currency: 'ZAR', maximumFractionDigits: 0
      }).format(variant.price / 100).replace(/\s/g, '');
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? 'Add to bag' : 'Edition closed';
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-product-option]')) update();
    });
    update();
  });
});
